import {
  addExpenseApi,
  getAccountFreghtList,
  getChartExpense,
  getChartRecipt,
  getCommonExpenseApi,
  getExpense,
  getUserAccountList,
  handleKeyDown,
  uploadFiles,
  venderDropdownApi,
} from "_services";
import { getConsignorListData } from "_services/accountsServices/consignorServices";
import { getSupplierListData } from "_services/accountsServices/supplierServices";
import { getVendersListData } from "_services/accountsServices/vendorsServices";
import { createPaymentInvoiceDetails, createTdsInvoiceDetails } from "_services/invoiceBillRaiseServices";
import {
  CommonCanvas,
  CommonDatePicker,
  CommonInput,
  CommonModal,
  CustomSelect,
  SkeletonInput,
} from "components";
import { UserContext } from "context";
import { addTransationConsignor, addTransationFreight } from "features";
import { errorSchema, utils } from "helper";
import AddEditModal from "modals/AddEditModal";
import moment from "moment";
import Loading from "pages/Loading";
import React, { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { IoCloseCircle } from "react-icons/io5";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import StorageService from "utils/StorageServices/StorageServices";

const AddTdsInvoiceModal = (props) => {

  const { closeModal, filterData, callInvoiceDetailsApi } = props;

  let { id } = useParams();

  const initiFrom = {
    date: new Date(),
    description: '',
    amount: '',
    company_id: StorageService.getCompanyId(),
    billraise_id: id ? id : '',
    consignor_id: filterData?.consignor_id?.value ? filterData?.consignor_id?.value : '',
    // tds_percentage: { value: 1, label: '1%' },
  };

  const { masterData } = useContext(UserContext);
  const [form, setForm] = useState(initiFrom);
  const [formError, setFormError] = useState("");
  const [loading, setLoading] = useState(false);
  const [isLoadingSave, setIsLoadingSave] = useState(false);

  const handleOnChange = async (name, value) => {
    const stateObj = {
      ...form,
      [name]: value,
    };
    setForm(stateObj);

    if (!!formError) {
      const validationResult = await utils.checkFormError(
        { ...stateObj },
        errorSchema.createTdsInvoiceDetailsSchema
      );
      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  const onSubmitExpense = async () => {
    const validationResult = await utils.checkFormError(
      { ...form },
      errorSchema.createTdsInvoiceDetailsSchema
    );

    if (validationResult === true) {
      setLoading(true);
      try {
        const payload = {
          ...form,
          amount: form?.amount,
          date: utils.convertToISO(form?.date, true),
          description: form?.description,
          // tds_percentage: form?.tds_percentage?.value
        };
        const res = await createTdsInvoiceDetails(payload);
        if (res?.responseCode === 200) {
          setLoading(false);
          setIsLoadingSave(false);
          closeModal();
          callInvoiceDetailsApi();
          // callBackFreight();
        } else {
          setLoading(false);
          setIsLoadingSave(false);
        }
      } catch {
        setLoading(false);
        setIsLoadingSave(false);
      }

      // try {
      //   const payload = {
      //     ...form,
      //     amount: form?.amount,
      //     date: utils.convertToISO(form?.date,true),
      //     description: form?.description,
      //   };
      //   const res = await createTdsInvoiceDetails(payload);
      //   if (res?.responseCode === 200) {
      //     setLoading(false);
      //     closeModal();
      //     callInvoiceDetailsApi();
      //   } else {
      //     setLoading(false);
      //   }
      // } catch {
      //   setLoading(false);
      // }
    } else {
      setFormError(validationResult);
    }
  };

  const modifyProps = {
    ...props,
    // isLoadding: loading,
    // disabled: loading,
    onSubmit: onSubmitExpense,
    // isLoadingSave: isLoadingSave,
  };

  return (
    <div>
      <CommonCanvas {...modifyProps}>
        <div className="offcanvas-body">
          <div className="_lrCl_offCavBody">
            <div className="_clPay_flex">

              <div className="singleDiv">
                <CommonDatePicker
                  name="date"
                  label="Payment Receipt Date & Time"
                  startDate={form?.date}
                  setStartDate={(data) => {
                    handleOnChange("date", data);
                  }}
                  error={formError?.date}
                  focus={!!formError?.date}
                />
              </div>

              <div className="singleDiv">
                <CommonInput
                  type="text"
                  label="Notes"
                  placeholder="Notes"
                  name="description"
                  value={form?.description}
                  onChange={({ target: { name, value } }) => {
                    handleOnChange(name, value);
                  }}
                  focus={!!formError?.description}
                  error={formError.description}
                />
              </div>

              {/* <div className="singleDiv">
                <CustomSelect
                  options={masterData.tds_section_list?.map((item) => {
                    return {
                      label: item?.name,
                      value: item?.id
                    }
                  })}
                  label="TDS Deduction %"
                  placeholder="TDS Deduction %"
                  name="tds_percentage"
                  onSelect={(data) => handleOnChange("tds_percentage", data)}
                  value={form?.tds_percentage}
                  focus={!!formError['tds_percentage.label']}
                  error={formError['tds_percentage.label']}
                />
              </div> */}

              <div className="singleDiv">
                <CommonInput
                  type="text"
                  label="Amount (₹)"
                  placeholder="Amount (₹)"
                  name="amount"
                  value={form.amount}
                  onChange={({ target: { name, value } }) => {
                    handleOnChange(name, value);
                  }}
                  maxLength={10}
                  onKeyDown={handleKeyDown}
                  focus={!!formError?.amount}
                  error={formError.amount}
                />
              </div>

            </div>
          </div>
        </div>
      </CommonCanvas>
    </div>
  );
};

export default AddTdsInvoiceModal;
